import React from 'react';
import AutoCompleteInput from './';

export default class SuburbAutoComplete extends React.Component {
    constructor(props) {
        super(props);
        const state_nz = {};
        const state_au = {};
        this.state = {au:{},nz:{}}
        console.log(this.props.extras)
        const localNz = (sessionStorage.getItem("globals_nz") == null || sessionStorage.getItem("globals_nz") == 'undefined' || sessionStorage.getItem("globals_nz") == "") ? this.props.extras : JSON.parse(sessionStorage.getItem("globals_nz"));
        const localAu = (sessionStorage.getItem("globals_au") == null || sessionStorage.getItem("globals_au") == 'undefined' || sessionStorage.getItem("globals_au") == "") ? this.props.extras : JSON.parse(sessionStorage.getItem("globals_au"));
        // could abstract this behind a GlobalsApi similar to the MembersApi,
        // which would allow swapping out to remote searching if required
        //const selected_country = this.props.country;
        
        if (localNz != null && localNz.suburbs) {
            let localityDataSet = localNz.suburbs.filter(l => l.suburb); // only use rows where suburb exists
            let suburbs = localityDataSet.map((l, i) => ({
                id: i,
                key: l.suburb.toLowerCase().trim(),
                display: `${l.suburb.trim()}, ${l.state.trim()}, ${l.postcode.trim()}`,
                value: l.suburb.trim(),
                ...l
            })); 

            state_nz.suburbs = suburbs;
            state_nz.localityDataSet = localityDataSet;
            this.state["nz"] = state_nz;
        }

        if (localAu != null && localAu.suburbs) {
            let localityDataSet = localAu.suburbs.filter(l => l.suburb); // only use rows where suburb exists
            let suburbs = localityDataSet.map((l, i) => ({
                id: i,
                key: l.suburb.toLowerCase().trim(),
                display: `${l.suburb.trim()}, ${l.state.trim()}, ${l.postcode.trim()}`,
                value: l.suburb.trim(),
                ...l
            })); 

            state_au.suburbs = suburbs;
            state_au.localityDataSet = localityDataSet;
            this.state["au"] = state_au;
        }
        
        this.searchSuburbs = this.searchSuburbs.bind(this);
        this.onSuburbSelected = this.onSuburbSelected.bind(this);
        //console.log(this.state);
    }

    componentDidUpdate(prevProps){
        
        let state_nz = {};
        let state_au = {};
        const localNz = (sessionStorage.getItem("globals_nz") == null || sessionStorage.getItem("globals_nz") == 'undefined' || sessionStorage.getItem("globals_nz") == "") ? this.props.extras : JSON.parse(sessionStorage.getItem("globals_nz"));
        const localAu = (sessionStorage.getItem("globals_au") == null || sessionStorage.getItem("globals_au") == 'undefined' || sessionStorage.getItem("globals_au") == "") ? this.props.extras : JSON.parse(sessionStorage.getItem("globals_au"));
        console.log(this.props.value, prevProps.value);    
           if(this.props.country == 'globals_au' || this.props.country == 'globals_nz'){
            
                if(this.props.extras !== prevProps.extras){
            
                if (localAu != null && localAu.suburbs) {
        
                    let localityDataSet = localAu.suburbs.filter(l => l.suburb); // only use rows where suburb exists
                    let suburbs = localityDataSet.map((l, i) => ({
                        id: i,
                        key: l.suburb.toLowerCase().trim(),
                        display: `${l.suburb.trim()}, ${l.state.trim()}, ${l.postcode.trim()}`,
                        value: l.suburb.trim(),
                        ...l
                    })); 
        
                    state_au.suburbs = suburbs;
                    state_au.localityDataSet = localityDataSet;
                    
                        
                        this.setState({
                            'au': state_au,
                            });
                    
                }

                if (localNz != null && localNz.suburbs) {
                    let localityDataSet = localNz.suburbs.filter(l => l.suburb); // only use rows where suburb exists
                    let suburbs = localityDataSet.map((l, i) => ({
                        id: i,
                        key: l.suburb.toLowerCase().trim(),
                        display: `${l.suburb.trim()}, ${l.state.trim()}, ${l.postcode.trim()}`,
                        value: l.suburb.trim(),
                        ...l
                    })); 

                    state_nz.suburbs = suburbs;
                    state_nz.localityDataSet = localityDataSet;
                    
                        
                        this.setState({
                            'nz': state_nz,
                            });
                    
                }
            }
        }
    }

    onChange = (event) => {
        this.props.onChange(event);
    };

    onSuburbSelected = (suburbId) => {
        
        let suburbs = [];
        if(this.props.country == "globals_au"){
            suburbs = this.state["au"]["suburbs"];
        }

        if(this.props.country == "globals_nz"){
            suburbs = this.state["nz"]["suburbs"];
        }

        if (!suburbs) {
            return;
        }
        const suburb = suburbs.find(s => s.id === suburbId);
        if (!suburb) {
            return;
        }
        this.props.onSuburbSelected({
            suburb: suburb.suburb,
            postcode: suburb.postcode,
            state: suburb.state
        });
    };

    searchSuburbs(_value) {
        
        const value = _value.toLowerCase().trim();
        let suburbs = [];
        if(this.props.country == "globals_au"){
            suburbs = this.state["au"]["suburbs"];
            //console.log("oop",suburbs);
        }

        if(this.props.country == "globals_nz"){
            suburbs = this.state["nz"]["suburbs"];
            //console.log("oos",suburbs);
        }

        if (suburbs) {
            const matches = suburbs.filter(sub => sub.key.indexOf(value) === 0)
            // const matches = suburbs.filter(sub => re.exec(sub.key));
            const distanceMatches = matches.map(m => ({ ...m, dist: m.key.length - value.length }));
            distanceMatches.sort((a, b) => a.dist - b.dist);
            return distanceMatches;
        }
        return [];
    }

    render() {
        
        return (
            <AutoCompleteInput
                name={this.props.name}
                label={this.props.label}
                value={this.props.value}
                onChange={this.onChange}
                onSelected={this.onSuburbSelected}
                error={this.props.error}
                getSuggestions={this.searchSuburbs}
                country={this.props.country}
            />
        );
    }
}

